import { render } from "./index.vue?vue&type=template&id=2ff583e6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2ff583e6&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=2ff583e6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff583e6"],['__file',"src/components/BaseUi/BenefitAndOfferDetailsCards/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ff583e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ff583e6', __exports__)) {
    api.reload('2ff583e6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2ff583e6&scoped=true", () => {
    api.rerender('2ff583e6', render)
  })

}


export default __exports__